// extracted by mini-css-extract-plugin
export default {"container":"kVQ_2","label":"_sHmb","input":"panpr","inputContainer":"sHaRe"};